import React from "react";

import styled from "styled-components";



import { Form } from "rsuite";

const ContactCustomField = ({ name, message, label, widthLabel, accepter, error, width = 180, ...props }) => {
    return (
        <StyledFormGroup
            className={error ? "has-error" : ""}
            width={width}
        >
            <Form.Control
                name={name}
                accepter={accepter}
                errorMessage={error}
                errorPlacement="topRight"
                {...props}
            />
            <Form.HelpText>{error}</Form.HelpText>
        </StyledFormGroup>
    );
};

export default ContactCustomField;

const StyledFormGroup = styled(Form.Group)`
    && {
        margin-bottom: 10;
        margin-right: 5;
        width: ${props => props.width}px;
    }
    
    &&.rs-form-group .rs-input {
        width: 100%;
    }

    &&.rs-form-group .rs-form-control-wrapper {
        width: 100%;
    }

    && {
        .rs-icon {
            position: absolute;
            right: 10px;
            color: var(--color-green);
        }
    }
`;